// Palette colori centralizzata
export const colors = {
  primary: '#397aa3',
  primaryDark: '#2e6484',
  background: '#ecedf3',
  white: '#ffffff',
  success: '#2e7d32',
  successLight: 'rgba(46, 125, 50, 0.08)',
  successHover: 'rgba(46, 125, 50, 0.16)',
  error: '#d32f2f',
  errorLight: 'rgba(211, 47, 47, 0.08)',
  errorHover: 'rgba(211, 47, 47, 0.16)',
  textPrimary: '#333333',
  textSecondary: '#666666',
  textDisabled: '#cccccc',
  headerBackground: '#f5f5f5',
  border: '#999999',
};

// Tema Grommet condiviso
export const grommetTheme = {
  global: {
    colors: {
      brand: colors.primary,
      'accent-1': 'white',
      'focus': colors.background,
      'my-text-color': '',
      background: colors.background,
    },
    font: {
      family: '',
      size: '18px',
      height: '20px',
      color: colors.primary,
    },
    select: {
      options: {
        extend: {
          fontWeight: 'bold',
        },
      },
    },
  },
  layer: {
    border: {
      radius: 'large',
      intelligentRounding: true,
    },
  },
};

// Stile bottone primario (blu brand)
export const buttonStyles = {
  primary: {
    width: '138px',
    height: '34px',
    fontSize: '15px',
    background: colors.primary,
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
};

// Stili base per DataGrid
export const dataGridStyles = {
  base: {
    border: 'none',
    borderRadius: '8px',
    '& .MuiDataGrid-columnHeaders': {
      backgroundColor: colors.headerBackground,
      borderRadius: '8px 8px 0 0',
    },
  },
};

// Stile Layer/Dialog
export const layerStyles = {
  dialog: {
    borderRadius: '16px',
    overflow: 'hidden',
  },
};

// Stile ToggleButtonGroup (ricerca)
export const toggleButtonGroupStyles = {
  '& .MuiToggleButton-root': {
    textTransform: 'none',
    '&.Mui-selected': {
      backgroundColor: colors.primary,
      color: 'white',
      '&:hover': { backgroundColor: colors.primaryDark },
    },
  },
};
